import { useState, useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { apiFetch } from '../lib/api';

export default function PrivacyPolicy() {
  const [settings, setSettings] = useState<Record<string, string>>({});

  useEffect(() => {
    apiFetch<Record<string, string>>('/api/public/settings').then((res) => {
      if (res.success && res.data) setSettings(res.data);
    });
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main className="py-12 px-4">
        <div className="container-max mx-auto max-w-3xl">
          <div className="bg-white rounded-2xl shadow-sm border border-brand-100 p-8 sm:p-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">{settings.privacyPolicyTitle || '隱私政策'}</h1>
            <p className="text-sm text-gray-500 mb-8">最後更新日期：{settings.privacyPolicyDate || '2026年5月1日'}</p>

            <div className="space-y-6 text-gray-700 leading-relaxed text-sm">
              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">1. 資料收集</h2>
                <p>我們可能會收集以下類型的個人資料：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li><strong>聯絡資料</strong>：姓名、電話號碼、電郵地址（用於捐款確認及收據發送）</li>
                  <li><strong>捐款記錄</strong>：捐款金額、日期、支付方式（用於財務紀錄及感謝信發送）</li>
                  <li><strong>裝置資訊</strong>：IP 地址、瀏覽器類型（用於網站安全及優化）</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">2. 資料用途</h2>
                <p>您的個人資料將用於以下目的：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li>處理及確認您的捐款</li>
                  <li>發送捐款收據及感謝信</li>
                  <li>回應您的查詢及提供客戶支援</li>
                  <li>發送活動資訊及機構通訊（僅在您同意的情况下）</li>
                  <li>遵守法律及監管要求</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">3. 資料保護</h2>
                <p>我們採取適當的技術及組織措施保護您的個人資料，包括：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li>使用加密技術保護數據傳輸（HTTPS/TLS）</li>
                  <li>限制員工對個人資料的存取權限</li>
                  <li>定期進行安全審查及漏洞掃描</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">4. 資料分享</h2>
                <p>我們不會出售或出租您的個人資料予第三方。我們僅在以下情況下分享資料：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li>經您明確同意的情況下</li>
                  <li>為遵守法律義務或法院命令</li>
                  <li>與可信賴的服務提供商合作（如支付處理商），且僅限於必要的服務範圍</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">5. Cookie 使用</h2>
                <p>我們使用 Cookie 及類似技術來改善網站體驗、分析流量及記住您的偏好。您可以隨時在瀏覽器設定中禁用 Cookie，但這可能影響部分網站功能。</p>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">6. 您的權利</h2>
                <p>根據《個人資料（私隱）條例》，您有權：</p>
                <ul className="list-disc list-inside mt-2 space-y-1 text-gray-600">
                  <li>查閱我們持有的您的個人資料</li>
                  <li>要求更正不準確的資料</li>
                  <li>要求刪除您的個人資料（在法律允許的範圍內）</li>
                  <li>反對接收直接促銷訊息</li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-bold text-gray-900 mb-2">7. 聯絡我們</h2>
                <p>如您對本隱私政策有任何疑問，或希望行使您的權利，請聯絡我們：</p>
                <div className="mt-2 text-gray-600">
                  <p>電郵：{settings.contactEmail || 'eva@s2c.org.hk'}</p>
                  <p>電話：{settings.contactPhone || '+852 9466 3081'}</p>
                  <p>地址：{settings.contactAddress || '香港九龍深水埗'}</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
